import React from 'react';


import { motion } from 'framer-motion';
import officeimg from '../../Assets/Home/Photos/SaptagonOffice5.png';
import aboutBanner from '../../Assets/AboutUs/AboutBanner.png';

const equipmentList = [
  '3D Laser-Based Network Survey Vehicles',
  'Laser Dynamic Deflectometer (LDD)',
  'PRIMAX 3500 Heavy Weight Deflectometer (HWD)',
  'Vehicle-Mounted Falling Weight Deflectometer (FWD)',
  'Mobile Bridge Inspection Unit (MBIU)',
  'Bridge Health Monitoring System (BHMS)',
  'Wireless Structural Health Monitoring',
  'Tunnel Defect Detection System (TDDS)',
];

const Hero = () => {
  const textVariant = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { type: 'spring', stiffness: 50, delay: 0.2 } },
  };

  const imageVariant = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { opacity: 1, scale: 1, transition: { type: 'spring', stiffness: 50, delay: 0.4 } },
  };

  return (
    <div className="w-full">

      {/* ================= HERO BANNER ================= */}
      <div className="relative h-[55vh] md:h-[52vh] lg:h-[55vh] w-full overflow-hidden">
        <img src={aboutBanner} alt="About Us" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/50"></div>
        <div className="relative z-10 h-full flex items-end px-6 md:px-16 pb-12 md:pb-14">
          <div>
            <h1 className="text-white text-4xl md:text-6xl lg:text-7xl font-bold">About Us</h1>
            <div className="w-14 h-1 bg-cyan-400 mt-4"></div>
            <p className="text-white/90 mt-4 text-sm md:text-base tracking-widest">
              BUILDING A SMARTER, SAFER AND SUSTAINABLE TOMORROW
            </p>
          </div>
        </div>
      </div>

      {/* ================= ABOUT SECTION ================= */}
      <div className="relative w-full overflow-hidden">
        <div className="flex flex-col lg:flex-row items-start justify-between gap-10 px-6 md:px-12 lg:px-16 xl:px-24 py-16 lg:py-20">

          {/* ================= TEXT SECTION ================= */}
          <motion.div
            className="w-full lg:w-[55%] flex flex-col gap-6 z-10"
            initial="hidden"
            animate="visible"
            variants={textVariant}
          >
            <p className="darkblue text-4xl md:text-5xl xl:text-6xl font-bold">
              <span className="highlightblue">SAPTAGON</span>
            </p>
            <div className="w-14 h-1 bg-cyan-400"></div>

            <p className="purple text-xl md:text-2xl font-semibold">
              Growing with India. Building for Bharat.
            </p>

            <p className="text-gray-800 text-sm md:text-base lg:text-[15px] xl:text-base text-justify leading-relaxed">
              For over a decade, Saptagon Asia Pvt. Ltd. has believed that India's growth story is
              written on the roads, railways, and bridges we help build. Today, that belief drives
              our mission — engineering the infrastructure of a Vikshit Bharat, one project at a time.
            </p>

            <p className="text-gray-800 text-sm md:text-base lg:text-[15px] xl:text-base text-justify leading-relaxed">
              From Detailed Project Reports and Feasibility Studies to Authority Engineering,
              Independent Engineering, and Project Management Consultancy, we've stood alongside
              India's infrastructure push — delivering the Operations, Maintenance, and Safety
              Consultancy that keeps a growing nation moving safely.
            </p>

            <p className="text-gray-800 text-sm md:text-base lg:text-[15px] xl:text-base text-justify leading-relaxed">
              We brought India's first Laser Dynamic Deflectometer (LDD) into our fleet —
              technology built for a safer India, capable of assessing road strength without
              disrupting traffic or people's daily lives. It sits alongside our NABL-accredited
              lab and a full suite of in-house survey and monitoring machinery:
            </p>

            <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-3">
              {equipmentList.map((item) => (
                <li key={item} className="flex items-start gap-2 text-gray-800 text-sm md:text-[15px]">
                  <span className="mt-2 w-1.5 h-1.5 rounded-full bg-cyan-400 shrink-0" />
                  {item}
                </li>
              ))}
            </ul>

            <p className="text-gray-800 text-sm md:text-base lg:text-[15px] xl:text-base text-justify leading-relaxed border-l-4 border-cyan-400 pl-4 italic">
              This is how we define Sustainable India — not as a slogan, but as infrastructure
              engineered to last, monitored to stay safe, and built to serve generations.
            </p>
          </motion.div>

          {/* ================= OFFICE IMAGE ================= */}
          <motion.div
            className="w-full lg:w-[42%] flex justify-center lg:justify-end z-10"
            initial="hidden"
            animate="visible"
            variants={imageVariant}
          >
            <img
              src={officeimg}
              alt="Saptagon Office"
              className="w-full max-w-[650px] h-auto rounded-3xl border-[6px] border-[#4db5c5] shadow-lg object-cover"
            />
          </motion.div>

        </div>
      </div>
    </div>
  );
};

export default Hero;